import React, { Component } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, Label, Input, Col } from 'reactstrap';
import './TotalCss.css'
import './FetchData.css';
import { api_url } from "./globalFunction/global_string";
import Swal from 'sweetalert2';
import { SelectUnit } from "./BasicComponents/SelectUnit";
import { SelectResearchUrl } from "./BasicComponents/SelectResearchUrl";
import { SelectNet } from "./BasicComponents/SelectNet";
import { SelectUnitproxyApply } from "./BasicComponents/SelectUnitproxyApply";
import DataTable from 'react-data-table-component';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const userTypeMapping = {
  "超級管理員": "S",
  "區網管理員": "M",
  "單位使用者": "N",
  "無權限訪客": "G"
};

export class FetchDataUserTable extends Component {
  static displayName = FetchDataUserTable.name;

  constructor(props) {
    super(props);
    this.state = {
      fetchDataForUserTable: props.fetchDataForUserTable,
      isFetchDatUserTable: props.isFetchDataUserTable,
      forecasts: [],
      originalForecasts: [],
      loading: true,
      sortColumn: null,
      columnSort: { url_addr: 'asc', unit_name: 'asc', build_id: 'asc', build_date: 'asc' },
      modal: false, informationModal: false, userdomainModal: false,
      editingItem: null,
      selectedUserType: '',
      selectedLocalNetName: '',
      selectedUserName: '',
      selectedLocalUnitName: '',
      selectedUnitId: '',
      selecteduseremail: '',
      userTypeOptions: ["超級管理員", "區網管理員", "單位使用者", "無權限訪客"],
      localNetNameOptions: [],
      unitNameOptions: [],
      allUnitNameOptions: [],
      selectedUnitId: '00000',
      account_R: '',
      name_R: '',
      email_R: '',
      fullName_R: '',
      Net_R: '',
      Unit_R: '',
      serviceUnit_R: '',
      serviceOffice_R: '',
      phoneExtension_R: '',
      title_R: '',
      selectnet: '',
      selectedUnitproxy: '',
      selectuser_type: '',
      filterText: '',
    };
  }
  //取得區網資訊
  GetUserOptions() {
    fetch(api_url + '/api/Async/GetUserOptions', {
      method: 'POST',
      headers: { "Authorization": localStorage.getItem('accessToken') },
    })
      .then(response => response.json())
      .then(data => {
        if (data && data.row) {
          const options = data.row.map(item => ({
            value: item.item1,
            label: item.item2
          }));
          this.setState({
            originalLocalNetNameOptions: options,
            localNetNameOptions: options,
          }, () => {
            const selectedUserType = this.state.selectedUserType;
            this.handleUserTypeChange({ target: { value: selectedUserType } });
          });
        } else {
          // 處理數據不完整或不正確的情況
          console.error('Invalid data received:', data);
        }
      })

  }
  //取得單握資訊
  GetUnitNameOptions() {
    fetch(api_url + '/api/Async/GetUnitNameOptions', {
      method: 'POST',
      headers: { "Authorization": localStorage.getItem('accessToken') },
    })
      .then(response => response.json())
      .then(data => {
        this.setState({
          allUnitNameOptions: data.row,
          unitNameOptions: data.row
        });
      })
      .catch(error => {
        console.error('Error fetching unit name options:', error);
      });
  }

  componentDidMount() {
    this.populateWeatherData();
    this.GetUserOptions();
    this.GetUnitNameOptions();
  }
  componentDidUpdate(prevProps, prevState) {
    // 如果 selectedUserType 改變了，則重新獲取區網和單位資料
    if (prevState.selectedUserType !== this.state.selectedUserType) {
      this.handleUserTypeChange({ target: { value: this.state.selectedUserType } });
    }

    // 如果 selectedLocalNetName 改變了，則重新獲取單位資料
    if (prevState.selectedLocalNetName !== this.state.selectedLocalNetName) {
      this.handleLocalNetNameChange({ target: { value: this.state.selectedLocalNetName } });
    }

    if (prevState.selectnet !== this.state.selectnet ||
      prevState.selectedUnitproxy !== this.state.selectedUnitproxy ||
      prevState.selectuser_type !== this.state.selectuser_type) {
      this.populateWeatherData();
    }
  }

  //判斷使用者權限帶出區網資料再帶出單位資料
  handleUserTypeChange = e => {
    const selectedUserType = e.target.value;
    //console.log(selectedUserType)
    const localNetNameOptions = this.filterLocalNetNameOptions(selectedUserType);

    const selectedLocalNetNameCode = localNetNameOptions[0]?.value || ''; // 選擇第一個選項或者設為空

    this.setState(prevState => ({
      ...prevState,
      selectedUserType,
      localNetNameOptions,
      selectedLocalNetName: selectedLocalNetNameCode, // 這裡設置新的 selectedLocalNetName
      unitNameOptions: this.updateUnitNameOptions(selectedUserType, selectedLocalNetNameCode)
    }), () => {
      // 在這裡觸發 handleLocalNetNameChange
      this.handleLocalNetNameChange({ target: { value: this.state.selectedLocalNetName } });
    });
  };

  //判斷使用者權限帶出區網資料
  filterLocalNetNameOptions = (userType) => {
    //console.log("filterLocalNetNameOptions userType:", userType);
    let localNetNameOptions = [...this.state.originalLocalNetNameOptions];
    //console.log(localNetNameOptions)
    switch (userType) {
      case "G":
        localNetNameOptions = [];
        break;
      case "N":
        localNetNameOptions = localNetNameOptions.filter(
          option => option.value !== 'SU');
        break;
      case "M":
        localNetNameOptions = localNetNameOptions.filter(
          option => option.value !== 'SU');
        break;
      case "S":
        localNetNameOptions = localNetNameOptions.filter(
          option => option.value === 'SU');
        break;
      default:
        localNetNameOptions = [...this.state.localNetNameOptions];
    }
    return localNetNameOptions;
  };

  openRegisterModal = (item) => {
    //console.log("openRegisterModal userType:", item);
    const selectedUserType = item.user_type;
    const localNetNameOptions = this.filterLocalNetNameOptions(selectedUserType);
    console.log(localNetNameOptions)
    const selectedLocalNetOption = this.state.localNetNameOptions.find(
      option => option.label === item.local_net_name
    );
    //console.log(selectedLocalNetOption)
    const selectedLocalNetName = selectedLocalNetOption ? selectedLocalNetOption.value : '';

    const unitNameOptions = this.updateUnitNameOptions(selectedUserType, selectedLocalNetName);

    const localUnitId = item.local_unit_name !== undefined ? item.local_unit_id : '00000';
    const selectedIndex = unitNameOptions.findIndex(
      option => option.item2 === localUnitId
    );
    const selectedLocalUnitName = unitNameOptions[0]?.item3 || '';
    // console.log({
    //   unitNameOptions,
    //   selectedLocalUnitName,
    //   selectedIndex,
    //   selectedUserType
    // });

    this.setState({
      modal: true,
      editingItem: item,
      selectedUserType: item.user_type,
      localNetNameOptions,
      selectedLocalNetName,
      selectedUserName: item.user_name,
      selectedLocalUnitName: item.local_unit_name,
      selectedIndex,
      selecteduseremail: item.e_mail,
      unitNameOptions,
      selectedLocalUnitName,
    });
  };

  //判斷使用者權限帶出區網資料再帶出單位資料(下拉選單的時候判斷)
  handleLocalNetNameChange = e => {
    const { selectedUserType, allUnitNameOptions } = this.state;
    const selectedLocalNetNameCode = e.target.value;
    //console.log(selectedLocalNetNameCode)
    //console.log(allUnitNameOptions)
    let filteredOptions = allUnitNameOptions.filter(
      item => item.item1 === selectedLocalNetNameCode
    );
    //console.log(filteredOptions)
    //console.log(selectedUserType)


    switch (selectedUserType) {
      case 'N':
        filteredOptions = filteredOptions.filter(item => item.item2 !== '00000');
        break;
      case 'M':
        filteredOptions = filteredOptions.filter(item => item.item2 === '00000');
        break;
      case 'S':
        filteredOptions = filteredOptions.filter(item => item.item2 === '00000');
        break;
      default:
    }
    let selectedLocalUnitName = filteredOptions[0]?.item3 || '';
    this.setState({
      selectedLocalNetName: selectedLocalNetNameCode,
      unitNameOptions: filteredOptions,
      selectedLocalUnitName: selectedLocalUnitName,
      selectedUnitId: filteredOptions[0]?.item2 || '00000'
    });
  };
  updateUnitNameOptions(selectedUserType, selectedLocalNetNameCode) {
    let unitNameOptions = this.state.allUnitNameOptions.filter(
      item => item.item1 === selectedLocalNetNameCode
    );
    switch (selectedUserType) {
      case 'N':
        unitNameOptions = unitNameOptions.filter(item => item.item2 !== '00000');
        break;
      case 'M':
      case 'S':
        unitNameOptions = unitNameOptions.filter(item => item.item2 === '00000');
        break;
      default:
    }
    return unitNameOptions;
  }


  closeRegisterModal = () => {
    this.setState({ modal: false, editingItem: null });
  };
  //刪除資料
  handleDelete = (id) => {
    Swal.fire({
      title: '確定要刪除這個帳號嗎？',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: '確定',
      cancelButtonText: '取消'
    }).then((result) => {
      if (result.isConfirmed) {
        const formData = new FormData();
        formData.append('user_id', id)

        fetch(api_url + '/api/Async/DeleteAsync0101', {
          method: 'POST',
          headers: { "Authorization": localStorage.getItem('accessToken') },
          body: formData
        })
          .then(response => response.json())
          .then(result => {
            if (result.statusCode === 200) {
              this.populateWeatherData();
            } else {
              console.error('更新失敗:', result);
            }
          })
          .catch(error => {
            console.log('Error fetching JSON:', error);
          });
      }
    })
  }

  saveChanges = () => {
    const loggedInUserId = localStorage.getItem('login_user_id');
    const { selectedLocalNetName } = this.state;
    const selectedUserType = this.state.selectedUserType;
    const userId = this.state.editingItem.user_id;
    const selectedUnitId = this.state.selectedUnitId;
    if (loggedInUserId === userId) {
      Swal.fire({
        icon: 'error',
        title: '【您不能修改當前登入的帳號權限。請用另一個帳號登入以進行修改】',
        text: 'sorry'
      });
      return;
    }
    const formData = new FormData();
    formData.append('currentUserId', this.props.fetchedData.current_user_type);
    formData.append('user_type', selectedUserType);
    formData.append('Local_net_id', selectedLocalNetName);
    formData.append('user_id', userId);
    formData.append('Local_unit_id', selectedUnitId);
    fetch(api_url + '/api/Async/PutLocalNetIdAsync0101', {
      method: 'POST',
      headers: {
        "Authorization": localStorage.getItem('accessToken'),
      },
      body: formData,
    })
      .then(response => response.json())
      .then(result => {
        console.log(result)
        if (result.result.statusCode === 200) {
          this.setState({
            selectedUserType: '',
            selectedLocalNetName: '',
            selectedLocalUnitName: '',
          });
          this.closeRegisterModal();
          this.populateWeatherData();
          this.GetUserOptions();
          this.GetUnitNameOptions();
        } else {
          console.error('更新失敗:', result);
        }
      })
      .catch(error => {
        console.log('Error fetching JSON:', error);
      });
  };

  //修改人員資訊
  openuserinformationModal = (item) => {
    //console.log(item)
    this.setState({
      informationModal: true,
      id: item.id,
      account_R: item.account_R,
      fullName_R: item.fullName_R,
      email_R: item.email_R,
      Net_R: item.Net_R,
      Unit_R: item.Unit_R,
      serviceUnit_R: item.serviceUnit_R,
      serviceOffice_R: item.serviceOffice_R,
      phoneExtension_R: item.phoneExtension_R,
      title_R: item.title_R,
    });
  };
  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };
  saveuserinformation = (e) => {
    e.preventDefault();

    let apiUrl = api_url + "/api/Async/UserModfity";
    const formData = new FormData();
    formData.append("user_type", localStorage.getItem('login_user_type'));

    formData.append("id", this.state.id);
    formData.append("user_id", this.state.account_R);
    formData.append("User_name", this.state.fullName_R);
    formData.append("E_mail", this.state.email_R);
    formData.append("servicenet", this.state.Net_R);
    formData.append("serviceunit_R", this.state.Unit_R);
    formData.append("serviceUnit", this.state.serviceUnit_R);
    formData.append("serviceOffice", this.state.serviceOffice_R);
    formData.append("phoneExtension", this.state.phoneExtension_R);
    formData.append("title", this.state.title_R !== undefined ? this.state.title_R : null);
    fetch(apiUrl,
      {
        method: "POST",
        headers: { "Authorization": localStorage.getItem('accessToken') },
        body: formData
      })
      .then(response => {
        try {
          return response.json();
        } catch (error) {
          console.error('Error parsing JSON:', error);
          throw error
        };
      })
      .then(data => {
        let arr_status = [String(data.statusCode), data.row, data.detail]
        switch (arr_status[0]) {
          case "200":
            Swal.fire({
              icon: 'success',
              title: '【修改成功】',
              text: '恭喜'
            })
            this.closeuserinformationModal();
            this.populateWeatherData();
            break;
          case "400":
            Swal.fire({
              icon: 'error',
              title: `${data.row}`,
              text: 'sorry'
            });
            break;
          case "500":
            window.location.href = '404'
            break;
          default:
        }
      })
      .catch(error => {
        console.error('Error:', error);
      });
  };

  closeuserinformationModal = () => {
    this.setState({ informationModal: false, editingItem: null });
  };

  openuserdomainModal = (forecast) => {
    //console.log(forecast)
    this.setState({
      userdomainModal: true,
      editingItem: forecast,
      selectedUserName: forecast.user_name,
      domain: forecast.domain,
      selectedUserId: forecast.user_id
    });
  };

  closeuserdomainModal = () => {
    this.setState({ userdomainModal: false, editingItem: null });
  };

  saveuserdomainChanges = () => {
    const Domain = JSON.stringify(this.state.domain);
    const formData = new FormData();
    formData.append('currentUserId', this.props.fetchedData.user_id);
    formData.append('user_name', this.state.selectedUserName);
    formData.append('user_id', this.state.selectedUserId);
    formData.append('domain', Domain);
    fetch(api_url + '/api/Async/PutUserDomain', {
      method: 'POST',
      headers: {
        "Authorization": localStorage.getItem('accessToken'),
      },
      body: formData,
    })
      .then(response => response.json()) // 提取 JSON 数据
      .then(result => {
        if (result.statusCode === 200) {
          Swal.fire({
            icon: 'success',
            title: '【修改成功】',
            text: '恭喜'
          });
          this.closeuserdomainModal();
          this.populateWeatherData();
        } else {
          Swal.fire({
            icon: 'error',
            title: `${result.detail}`,
            text: '更新失敗'
          });
          console.error('更新失敗:', result);
        }
      })
      .catch(error => {
        Swal.fire({
          icon: 'error',
          title: '【出錯了】',
          text: '無法完成請求'
        });
        console.log('Error fetching JSON:', error);
      });
  };

  // 處理網域選擇
  handleNetSelectChange = (data) => {
    const { value, selectedName } = data;
    this.setState((prevState) => ({
      selectnet: value,
      local_net_name: selectedName,
      selectedUnitproxy: '',  // 清空單位
      local_unit_proxy_name: '',  // 清空單位名稱
      formData: {
        ...prevState.formData,
        excel_unit_url: '',  // 清空網址
      }
    }), () => {
      // console.log("Selected net updated:", this.state.selectnet, this.state.local_net_name);
    });
  };

  SelectUnitproxyApply = (data) => {
    const { value, selectedName } = data;
    this.setState({ selectedUnitproxy: value, local_unit_proxy_name: selectedName }, () => {
      // console.log("Selected unit updated:", this.state.selectedUnitproxy, this.state.local_unit_proxy_name);
    });
  };
  handleUserTypeSelectChange = (event) => {
    this.setState({ selectuser_type: event.target.value });
  };
  // 獲取使用者類型文本
  getUserTypeText(userType) {
    switch (userType) {
      case "S": return "超級管理員";
      case "M": return "區網管理員";
      case "N": return "單位使用者";
      default: return "無權限訪客";
    }
  }
  handleFilterChange = (e) => {
    const originalForecasts = this.state.originalForecasts || this.state.forecasts;
    const filterText = e.target.value;
    let updatedForecasts;
    if (filterText) {
      updatedForecasts = originalForecasts.filter((item) => {
        const searchString = `${item.local_net_name}${item.local_unit_name}${this.getUserTypeText(item.user_type)}${item.user_name}${item.user_id}${item.domain}`.toLowerCase();
        return searchString.includes(filterText.toLowerCase());
      });
    } else {
      updatedForecasts = originalForecasts;
    }

    this.setState({ filterText, forecasts: updatedForecasts });
  };

  columns = [
    {
      name: '操作',
      cell: row => (
        <div>
          <Button color="primary" className="mx-2" onClick={() => this.openRegisterModal(row)}>編輯權限</Button>
          <Button color="info" className="mx-2" onClick={() => this.openuserinformationModal(row)}>編輯個人資料</Button>
          <Button color="success" className="mx-2" onClick={() => this.openuserdomainModal(row)}>編輯網域資料</Button>
          <Button color="danger" className="mx-2" onClick={() => this.handleDelete(row.user_id)}>刪除</Button>
        </div>
      ),
    },
    {
      name: '使用者權限',
      selector: row => this.getUserTypeText(row.user_type),
      sortable: true,
    },
    {
      name: '使用者區網名稱',
      selector: row => row.local_net_name,
      sortable: true,
    },
    {
      name: '使用者單位名稱',
      selector: row => row.local_unit_name,
      sortable: true,
    },
    {
      name: '使用者名稱',
      selector: row => row.user_name,
      sortable: true,
    },
    {
      name: '使用者帳號',
      selector: row => row.user_id,
      sortable: true,
    },
    {
      name: '使用者網域資料',
      selector: row => row.domain,
      sortable: true,
      cell: row => (
        <div style={{
          minWidth: '200px', // 根據需要調整最小寬度
          maxWidth: '100%', // 使得單元格寬度不超過其容器的寬度
          whiteSpace: 'normal', // 允許文本換行
          overflow: 'hidden', // 隱藏超出單元格範圍的文本
          textOverflow: 'ellipsis', // 用省略號表示被截斷的文本
          border: 'none', // 無邊框
          padding: '10px', // 內邊距
          backgroundColor: 'transparent', // 透明背景
          lineHeight: '1.6', // 行高
        }}>
          {row.domain}
        </div>
      ),
    }
  ];


  // renderTableHeader() {
  //   return (
  //     <thead>
  //       <tr>
  //         <th className='nancy_table_width20'>
  //           <div className="nancy-table-topC">操作</div></th>
  //         <th className='nancy_table_width15'>
  //           <div className="nancy-table-topC">使用者權限</div></th>
  //         <th className='nancy_table_width15'>
  //           <div className="nancy-table-top">使用者區網名稱</div></th>
  //         <th className='nancy_table_width15'>
  //           <div className="nancy-table-top">使用者單位名稱</div></th>
  //         <th className='nancy_table_width10'>
  //           <div className="nancy-table-topC">使用者名稱</div></th>
  //         <th className='nancy_table_width10'>
  //           <div className="nancy-table-topC">使用者帳號</div></th>
  //         <th className='nancy_table_width60'>
  //           <div className="nancy-table-top">使用者網域資料</div></th>
  //       </tr>
  //     </thead>
  //   );
  // }

  // renderTableBody(forecasts) {
  //   // console.log("render:", forecasts);
  //   return (
  //     <tbody>
  //       {forecasts.map(forecast => {
  //         let userTypeText;
  //         switch (forecast.user_type) {
  //           case "S":
  //             userTypeText = "超級管理員";
  //             break;
  //           case "M":
  //             userTypeText = "區網管理員";
  //             break;
  //           case "N":
  //             userTypeText = "單位使用者";
  //             break;
  //           default:
  //             userTypeText = "無權限訪客";
  //             break;
  //         }
  //         return (
  //           <tr key={forecast.id}>
  //             <td>
  //               <Button color="primary" className="mx-2" onClick={() => this.openRegisterModal(forecast)}>修改權限</Button>
  //               <Button color="info" className="mx-2" onClick={() => this.openuserinformationModal(forecast)}>使用者資料</Button>
  //               <Button color="success" className="mx-2" onClick={() => this.openuserdomainModal(forecast)}>使用者網域</Button>
  //               <Button color="danger" className="mx-2" onClick={() => this.handleDelete(forecast.user_id)}>刪除</Button>
  //             </td>
  //             <td>{userTypeText}</td>
  //             <td>{forecast.local_net_name}</td>
  //             <td>{forecast.local_unit_name}</td>
  //             <td>{forecast.user_name}</td>
  //             <td>{forecast.user_id}</td>
  //             <td>{forecast.domain}</td>
  //           </tr>
  //         )
  //       })}
  //     </tbody>
  //   );
  // }

  render() {
    const userType = localStorage.getItem('login_user_type');
    const net_name = localStorage.getItem('login_user_net_name');
    let FormDataUsertype;
    let contents;
    if (this.state.loading) {
      contents = <p><em>Loading...</em></p>;
    } else {
      contents = (
        <DataTable
          columns={this.columns}
          data={this.state.filteredForecasts || this.state.forecasts}
          pagination
          paginationRowsPerPageOptions={[10, 20, 50, 100, this.state.forecasts.length]}
          customStyles={{
            headRow: {
              style: { background: 'transparent' },
            },
            headCells: {
              style: { fontSize: '14px', fontWeight: 'bold' },
            },
          }}
          highlightOnHover
          responsive
          onRowClicked={(row) => console.log(row)} // Add this line if you want to handle row clicks
          subHeader
          subHeaderComponent={
            <div className="row  justify-content-end">
              <div className="col-md-4 input-group">
                <div className="input-group-prepend bg-info">
                  <span className="input-group-text bg-info" style={{ borderTopLeftRadius: '0.7rem', borderBottomLeftRadius: '0.7rem' }}>
                    <FontAwesomeIcon icon={faSearch} color="white" />
                  </span>
                </div>
                <Input
                  type="text"
                  placeholder="篩選-請輸入文字..."
                  value={this.state.filterText}
                  onChange={this.handleFilterChange}
                  className="form-control"
                />
              </div>
            </div>
          }
        />
      )
    }

    if (userType === 'S') {
      FormDataUsertype = (
        <div id="site_manage" className="row col-12 mb-5 justify-content-center">
          <FormGroup row className="col-12 col-md-10 col-lg-8">
            <Label for="local_net_id" sm={2}>區網名稱</Label>
            <Col sm={6}>
              <SelectNet
                parentName={'superS'}
                id={'excel_net_name'}
                name={'excel_net_name'}
                requiredAPI={'/api/JRCC/GetLocalNetId'}
                handleNetSelectChange={this.handleNetSelectChange}
              />
            </Col>
          </FormGroup>
          <FormGroup row className="col-12 col-md-10 col-lg-8">
            <Label for="excel_unit_proxy_name" sm={2}>單位名稱</Label>
            <Col sm={6}>
              <SelectUnitproxyApply
                parentName={'superS'}
                id={'excel_unit_proxy_name'}
                name={'excel_unit_proxy_name'}
                requiredAPI={'/api/Async/GetNetDownUnitlist'}
                SelectUnitproxyApply={this.SelectUnitproxyApply}
                selectnet={this.state.selectnet}
                local_net_name={this.state.local_net_name}
              />
            </Col>
          </FormGroup>
          <FormGroup row className="col-12 col-md-10 col-lg-8">
            <Label for="userTypeSelect" sm={2}>使用者權限</Label>
            <Col sm={6}>
              <select
                id="userTypeSelect"
                value={this.state.selectuser_type}
                onChange={this.handleUserTypeSelectChange}
                className="form-select"
              >
                <option value="">請選擇</option>
                {this.state.userTypeOptions.map(option => (
                  <option key={option} value={userTypeMapping[option]}>{option}</option>
                ))}
              </select>
            </Col>
          </FormGroup>
        </div>

      );
    } else if (userType === 'M') {
      FormDataUsertype = (
        <div id="site_manage" className="row col-12 mb-5 justify-content-center">
          <FormGroup row className="col-12 col-md-10 col-lg-8">
            <Label sm={2}>區網名稱</Label>
            <Col sm={10}>
              <span className="form-control-plaintext">{net_name}</span>
            </Col>
          </FormGroup>
          <FormGroup row className="col-12 col-md-10 col-lg-8">
            <Label for="excel_unit_proxy_name" sm={2}>單位名稱</Label>
            <Label for="excel_unit_name" sm={2}>單位名稱</Label>
            <Col sm={10}>
              {this.state.fetchedData.current_user_type === 'N' ? (
                <span className="form-control-plaintext">{this.state.firstLocalUnitName}</span>
              ) : (
                <SelectUnit
                  parentName={'Excel'}
                  id={'excel_unit_name'}
                  name={'excel_unit_name'}
                  requiredAPI={'/api/JRCC/GetLocalUnitId'}
                  onUnitSelectChange={this.handleUnitSelectChange}
                />
              )}
            </Col>
          </FormGroup>
          <FormGroup row className="col-12 col-md-10 col-lg-8">
            <Label for="userTypeSelect" sm={2}>使用者權限</Label>
            <Col sm={6}>
              <select
                id="userTypeSelect"
                value={this.state.selectuser_type}
                onChange={this.handleUserTypeSelectChange}
                className="form-select"
              >
                <option value="">請選擇</option>
                {this.state.userTypeOptions.map(option => (
                  <option key={option} value={userTypeMapping[option]}>{option}</option>
                ))}
              </select>
            </Col>
          </FormGroup>
        </div>

      );
    }
    return (
      <div className='mt-2'>
        {FormDataUsertype}
        <table id='tablelabel' className='table table-striped table-bordered dt-responsive nowrap vertical-align-center' aria-labelledby="tableLabel">
          {/* {this.renderTableHeader()} */}
          {contents}
        </table>


        <Modal isOpen={this.state.modal} toggle={this.closeRegisterModal}>
          <ModalHeader toggle={this.closeRegisterModal}>修改資料</ModalHeader>
          <ModalBody>
            <FormGroup>
              <Label for="userType">使用者權限</Label>
              <Input
                type="select"
                id="userType"
                value={this.state.selectedUserType}
                onChange={this.handleUserTypeChange} // 更改使用者類型時觸發事件
              >
                {this.state.userTypeOptions.map((option, index) => (
                  <option key={index} value={userTypeMapping[option]}>{option}</option>
                ))}
              </Input>
            </FormGroup>
            <FormGroup>
              <Label for="localNetName">使用者區網名稱</Label>
              <Input
                type="select"
                id="localNetName"
                value={this.state.selectedLocalNetName}
                onChange={this.handleLocalNetNameChange}
              >
                {this.state.localNetNameOptions.map((option, index) => (
                  <option key={index} value={option.value}>{option.label}</option>
                ))}
              </Input>
            </FormGroup>

            <FormGroup>
              <Label for="unitName">使用者單位名稱</Label>
              <Input
                type="select"
                id="unitName"
                value={this.state.selectedIndex} // 更改為 selectedIndex
                onChange={e => {
                  const selectedIndex = parseInt(e.target.value, 10);
                  const selectedItem = this.state.unitNameOptions[selectedIndex];
                  this.setState({
                    selectedIndex,
                    selectedUnitId: selectedItem.item2,
                    selectedLocalUnitName: selectedItem.item3
                  });
                }}
              >
                {this.state.unitNameOptions.map((option, index) => (
                  <option
                    key={index}
                    value={index}
                  >
                    {option.item3}
                  </option>
                ))}
              </Input>
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.saveChanges}>儲存</Button>
            <Button color="secondary" onClick={this.closeRegisterModal}>取消</Button>
          </ModalFooter>
        </Modal>


        <Modal isOpen={this.state.informationModal} toggle={this.closeuserinformationModal}>
          <ModalHeader toggle={this.closeuserinformationModal}>修改資料</ModalHeader>
          <ModalBody>
            <FormGroup row className="mb-3">
              <Label for="account_R" sm={2} className="text-right">帳號</Label>
              <Col sm={10}>
                <Input type="text" name="account_R" placeholder="Username" value={this.state.account_R} onChange={this.handleChange} onBlur={this.checkAccountAvailability} required />
              </Col>
            </FormGroup>
            <FormGroup row className="mb-3">
              <Label for="fullName_R" sm={2} className="text-right">姓名</Label>
              <Col sm={8}>
                <Input type="text" name="fullName_R" placeholder="王小名" value={this.state.fullName_R} onChange={this.handleChange} required />
              </Col>
            </FormGroup>
            <FormGroup row className="mb-3">
              <Label for="email_R" sm={2} className="text-right">信箱</Label>
              <Col sm={10}>
                <Input type="email" name="email_R" placeholder="Email" value={this.state.email_R} onChange={this.handleChange} required />
              </Col>
            </FormGroup>
            <FormGroup row className="mb-3">
              <Label for="Net_R" sm={2} className="text-right">區網</Label>
              <Col sm={10}>
                <Input type="text" name="Net_R" placeholder="竹苗區網" value={this.state.Net_R} onChange={this.handleChange} required />
              </Col>
            </FormGroup>

            <FormGroup row className="mb-3">
              <Label for="serviceUnit_R" sm={2} className="text-right">服務單位</Label>
              <Col sm={10}>
                <Input type="text" name="serviceUnit_R" placeholder="國立陽明交通大學" value={this.state.serviceUnit_R} onChange={this.handleChange} required />
              </Col>
            </FormGroup>
            <FormGroup row className="mb-3">
              <Label for="serviceOffice_R" sm={2} className="text-right">服務處室</Label>
              <Col sm={10}>
                <Input type="text" name="serviceOffice_R" placeholder="資訊技術服務中心" value={this.state.serviceOffice_R} onChange={this.handleChange} required />
              </Col>
            </FormGroup>
            <FormGroup row className="mb-3">
              <Label for="phoneExtension_R" sm={2} className="text-right">電話分機</Label>
              <Col sm={10}>
                <Input type="text" name="phoneExtension_R" placeholder="電話分機(030000000)分機(#123)" value={this.state.phoneExtension_R} onChange={this.handleChange} required />
              </Col>
            </FormGroup>
            <FormGroup row className="mb-3">
              <Label for="title_R" sm={2} className="text-right">職稱</Label>
              <Col sm={10}>
                <Input type="text" name="title_R" placeholder="組長" value={this.state.title_R} onChange={this.handleChange} />
              </Col>
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.saveuserinformation}>儲存</Button>
            <Button color="secondary" onClick={this.closeuserinformationModal}>取消</Button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={this.state.userdomainModal} toggle={this.closeuserdomainModal}>
          <ModalHeader toggle={this.closeuserdomainModal}>修改資料</ModalHeader>
          <ModalBody>
            <FormGroup>
              <Label for="userName">使用者名稱</Label>
              <Input type="text" id="userName" value={this.state.selectedUserName} onChange={e => this.setState({ selectedUserName: e.target.value })} readOnly />
            </FormGroup>
            <FormGroup>
              <Label for="domain">使用者網域資料</Label>
              <Input type="textarea" id="domain" value={this.state.domain} onChange={e => this.setState({ domain: e.target.value.trim() })} rows="5" style={{ resize: 'vertical' }} />
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.saveuserdomainChanges}>儲存</Button>{' '}
            <Button color="secondary" onClick={this.closeuserdomainModal}>取消</Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }

  async populateWeatherData() {
    const { selectnet, selectedUnitproxy, selectuser_type } = this.state;

    const formData = new FormData();
    formData.append("user_id", this.props.fetchedData.current_user_type);

    if (selectnet) {
      formData.append("local_net_id", selectnet);
    }

    if (selectedUnitproxy) {
      formData.append("local_unit_id", selectedUnitproxy);
    }
    // console.log(selectuser_type)
    if (selectuser_type) {
      formData.append("selectedUserType", selectuser_type);
    }


    await fetch(this.props.fetchedData.apiUrl, {
      method: "POST",
      headers: { "Authorization": localStorage.getItem('accessToken') },
      body: formData
    })
      .then(response => response.json())
      .then(data => {
        let arr_status = [String(data.statusCode), data.row, data.detail] //api 回傳判斷
        const rows = Array.isArray(arr_status[1]) ? arr_status[1] : [arr_status[1]];
        let combinedForecasts = {};
        data.row.forEach(item => {
          //console.log(item)
          if (combinedForecasts[item.user_id]) {
            combinedForecasts[item.user_id].domain += `,${item.domain}`;
          } else {
            combinedForecasts[item.user_id] = {
              user_id: item.user_id,
              user_name: item.user_name,
              domain: item.domain,
              local_net_name: item.local_net_name,
              local_unit_name: item.local_unit_name,
              id: item.id,
              account_R: item.user_id,
              fullName_R: item.user_name,
              email_R: item.e_mail,
              Net_R: item.servicenet,
              Unit_R: item.serviceunit_R,
              serviceUnit_R: item.serviceUnit,
              serviceOffice_R: item.serviceOffice,
              phoneExtension_R: item.phoneExtension,
              title_R: item.title,
              user_type: item.user_type
            };
          }
        });

        let forecasts = Object.values(combinedForecasts);
        this.setState({ forecasts: forecasts, loading: false, originalForecasts: forecasts });
      })
      .catch(error => {
        console.log('Error fetching JSON:', error);
      });
  }
}
